/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DirectoryEntry { 
    id: number;
    fullName: string;
    jobPositionName?: string | null;
    departmentId?: string | null;
    departmentName?: string | null;
    companyName?: string | null;
    email?: string | null;
    phone?: string | null;
    /**
     * URL absoluta y pública, lista para un <img src>
     */
    photoProfileUrl?: string | null;
}

